module.exports = __webpack_public_path__ + "img/logo.64cba47.png";